<div id="menu-container-am" class="mb-grid-container-full mb-grid-row">
  <div class="am-ctn--xxl mb-grid-col-12-dt">
    <div id="inner-menu" class="mb-container-full">
      <mb-tabs (selectedTabChange)="handleClickTab($event)" class="tabs-container">
        <mb-tab id="description">
          <mb-tab-title i18n="@@descripcion">Descripción</mb-tab-title>
        </mb-tab>
        <mb-tab
          id="rooms"
          *ngIf="(!error && !disableRooms) || (loading$ | async)"
          [disabled]="loading$ | async"
        >
          <mb-tab-title i18n="@@habitaciones">Habitaciones</mb-tab-title>
        </mb-tab>
        <mb-tab
          id="reviews"
          *ngIf="(!error && !disableReviews) || (loading$ | async)"
          [disabled]="loading$ | async"
        >
          <mb-tab-title i18n="@@opiniones">Opiniones</mb-tab-title>
        </mb-tab>
        <mb-tab
          id="related"
          *ngIf="(!error && !disableRelated) || (loading$ | async)"
          [disabled]="loading$ | async"
        >
          <mb-tab-title i18n="@@ofertas_similares">Ofertas Similares</mb-tab-title>
        </mb-tab>
      </mb-tabs>
    </div>
  </div>
</div>
